<mat-sidenav-container hasBackdrop="true" class="flex w-full flex-auto flex-col">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div class="flex justify-between w-full items-center">
        <div class="flex flex-col">

          <div class="flex items-center gap-1">
            <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
              <button mat-icon-button color="primary">
                <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
              </button>
            </div>

            <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
              <div class="p-4">
                <p>
                  Conecta tus cuentas (WhatsApp Business,
                  Facebook, Instagram) con AVE. Permite
                  recibir consultas y pedidos desde redes
                  y centralizarlos. Úsalo para atender más
                  rápido y mantener todo en un solo lugar..
                </p>
              </div>
            </mat-menu>

          <h2 class="text-xl font-semibold leading-8 tracking-tight">Redes Sociales</h2>
          </div>
          <div class="text-sm text-secondary font-medium tracking-tight">
            Mantenimiento que permite activar/inactivar, crear, actualiza y eliminar los registros.
          </div>
        </div>

        <app-status-filters
          [selectedStatuses]="selectedStatuses"
          [showStatus]="[1, 0]"
          (selectionFilterApply)="applyStatusFilter()"
        >
        </app-status-filters>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between"
      >
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Redes Sociales</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <!-- Add button (only icon) -->
          <button
            mat-icon-button
            color="primary"
            (click)="openCreateModal()"
            matTooltip="Nuevo Registro"
          >
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div
      class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent"
    >
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table
              class="w-full bg-transparent"
              mat-table
              [dataSource]="dataSource"
              matSort
              [trackBy]="trackByFn"
            >
              <!-- Nombre -->
              <ng-container matColumnDef="nombre">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-10 text-left">
                  Nombre
                </th>
                <td
                  mat-cell
                  *matCellDef="let socialMediaType"
                  class="pl-10 text-left text-uppercase"
                >
                  <div *ngIf="getCode(socialMediaType) as code">
                    <b class="f-10">{{ code }}</b>
                  </div>
                  {{ socialMediaType.name }}
                </td>
              </ng-container>

              <!-- Logo -->
              <ng-container matColumnDef="logo">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Logo</th>
                <td mat-cell *matCellDef="let socialMediaType" class="px-6 text-left">
                  <img
                    [src]="socialMediaType.logo.link"
                    alt="{{ socialMediaType.logo.name }}"
                    class="w-10 h-10"
                  />
                </td>
              </ng-container>

              <!-- Estado -->
              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
                <td mat-cell *matCellDef="let socialMediaType" class="px-6 text-left">
                  <mat-slide-toggle
                    class="custom-slide-toggle primary"
                    [checked]="socialMediaType.statusId == 1"
                    [(ngModel)]="socialMediaType.statusId"
                    [color]="'success'"
                    (ngModelChange)="onStatusChange($event, socialMediaType)"
                  >
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let socialMediaType" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openEditModal(socialMediaType)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteDialog(socialMediaType)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10 bg-white dark:bg-gray-900"
              ></tr>

              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-b"></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900">
          <mat-paginator
            class="z-10"
            [pageSizeOptions]="[50, 100, 150, 200]"
            showFirstLastButtons
            [length]="totalItems"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            (page)="onPageChange($event)"
          ></mat-paginator>
        </div>
      </div>

      <!-- Modales -->
      <ng-template #addModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
        <mat-dialog-content class="modal-content">
          <form #createForm="ngForm">
            <mat-form-field appearance="fill" class="modal-input">
              <mat-label>Nombre</mat-label>
              <input
                matInput
                [(ngModel)]="currentCreateSocialMediaType.name"
                name="name"
                required
              />
            </mat-form-field>

            <!-- Logo inputs -->
            <mat-form-field appearance="fill" class="modal-input">
              <mat-label>Tipo de Logo</mat-label>
              <input
                matInput
                [(ngModel)]="currentCreateSocialMediaType.logo.type"
                name="logoType"
                required
              />
            </mat-form-field>
            <mat-form-field appearance="fill" class="modal-input">
              <mat-label>Enlace del Logo</mat-label>
              <input
                matInput
                [(ngModel)]="currentCreateSocialMediaType.logo.link"
                name="logoLink"
                required
              />
            </mat-form-field>
            <mat-form-field appearance="fill" class="modal-input">
              <mat-label>Nombre del Logo</mat-label>
              <input
                matInput
                [(ngModel)]="currentCreateSocialMediaType.logo.name"
                name="logoName"
                required
              />
            </mat-form-field>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button
            mat-raised-button
            color="primary"
            (click)="createSocialMediaType()"
            [disabled]="!createForm.valid"
          >
            Guardar
          </button>
        </mat-dialog-actions>
      </ng-template>

      <!-- Modal Editar -->
      <ng-template #editModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
        <mat-dialog-content class="modal-content">
          <form #editForm="ngForm">
            <mat-form-field appearance="fill" class="modal-input">
              <mat-label>Nombre</mat-label>
              <input
                matInput
                [(ngModel)]="currentUpdateSocialMediaType.name"
                name="name"
                required
              />
            </mat-form-field>

            <!-- Logo inputs -->
            <mat-form-field appearance="fill" class="modal-input">
              <mat-label>Tipo de Logo</mat-label>
              <input
                matInput
                [(ngModel)]="currentUpdateSocialMediaType.logo.type"
                name="logoType"
                required
              />
            </mat-form-field>
            <mat-form-field appearance="fill" class="modal-input">
              <mat-label>Enlace del Logo</mat-label>
              <input
                matInput
                [(ngModel)]="currentUpdateSocialMediaType.logo.link"
                name="logoLink"
                required
              />
            </mat-form-field>
            <mat-form-field appearance="fill" class="modal-input">
              <mat-label>Nombre del Logo</mat-label>
              <input
                matInput
                [(ngModel)]="currentUpdateSocialMediaType.logo.name"
                name="logoName"
                required
              />
            </mat-form-field>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button
            mat-raised-button
            color="primary"
            (click)="updateSocialMediaType(currentUpdateSocialMediaType._id)"
            [disabled]="!editForm.valid"
          >
            Guardar
          </button>
        </mat-dialog-actions>
      </ng-template>

      <!-- Modal de eliminación -->
      <ng-template #deleteDialog let-data>
        <div class="flex items-start space-x-2 mb-4">
          <div class="flex items-center">
            <mat-icon
              svgIcon="heroicons_outline:exclamation-triangle"
              class="text-red-500 ml-4 mt-6"
              style="font-size: 32px"
            ></mat-icon>
          </div>
          <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
            <mat-dialog-content class="modal-content mt-0">
              <p>¿Está seguro que desea eliminar el registro?</p>
            </mat-dialog-content>
          </div>
        </div>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Conservar</button>
          <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
        </mat-dialog-actions>
      </ng-template>
    </div>
  </div>
</mat-sidenav-container>
